/* Vibranet — piccoli componenti UI. Nessuna dipendenza. */
(() => {
  /* ---------- schede prodotti (home) ---------- */
  if (!customElements.get('vbx-tabs')) {
    class VbxTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll(':scope > .vbx-tabs [role="tab"]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => this.onKey(e, i));
        });
      }

      onKey(e, i) {
        const last = this.tabs.length - 1;
        const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        this.select(next, true);
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (panel) panel.hidden = !on;
          if (on && focus) tab.focus();
          if (on && panel) {
            // immagini lazy della card: forza il ricalcolo quando il pannello diventa visibile
            window.dispatchEvent(new Event('resize'));
            if (window.lazySizes && window.lazySizes.loader) {
              panel.querySelectorAll('.lazyload').forEach((img) => window.lazySizes.loader.unveil(img));
            }
          }
        });
        const active = this.tabs[index];
        if (active && active.scrollIntoView && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
          active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }
    }
    customElements.define('vbx-tabs', VbxTabs);
  }

  /* ---------- "Visti di recente": stesse card delle collezioni ----------
     Le card arrivano via JS dopo il caricamento: aggiungiamo la classe delle colonne di collezione. */
  const markRecentlyViewed = () => {
    if (!document.querySelector('.vibranet-recently-viewed')) return;
    document.querySelectorAll('.vibranet-recently-viewed .swiper-slide:not(.vibranet-collection__product-col)').forEach((slide) => {
      slide.classList.add('vibranet-collection__product-col');
    });
  };
  const startRv = () => {
    if (!document.querySelector('intersection-observer[data-name="rvi"], .vibranet-recently-viewed')) return;
    markRecentlyViewed();
    new MutationObserver(markRecentlyViewed).observe(document.body, { childList: true, subtree: true });
  };

  /* ---------- collezione: il numero in alto segue i filtri ---------- */
  const syncCollectionCount = () => {
    const stat = document.querySelector('.vibranet-collection__stat span');
    const source = document.querySelector('.vibranet-collection__toolbar .ProductCountDesktop, .vibranet-collection .category-page-items-count');
    if (!stat || !source) return;
    const match = source.textContent.replace(/[.\s  ]/g, '').match(/\d+/);
    if (match) stat.textContent = match[0];
  };
  document.addEventListener('filter:updated', () => setTimeout(syncCollectionCount, 50));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startRv);
  } else {
    startRv();
  }
})();
